"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigationActions = exports.getNavigation = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _constants = require("./constants");
var _constants2 = require("../../resources/constants");
var _msalInstance = _interopRequireDefault(require("../../services/msalInstance"));
var _msalConfig = require("../../services/msalConfig");
var _oneWeir = require("@weirgroup/one-weir");
var _loader = require("../../loader/loader.actions");
var _languageMsg = require("./languageMsg");
const crypto = require('crypto');
Object.defineProperty(window, 'crypto', crypto);
const getNavigation = (applicationID, appName) => async dispatch => {
  _msalConfig.msalConfig.auth.redirectUri = "".concat(window.location.origin).concat(appName);
  _msalConfig.msalConfig.auth.clientId = applicationID;
  const msalInstance = new _msalInstance.default(_msalConfig.msalConfig);
  dispatch(_loader.loaderActions.show());
  const scopes = ['api://885ee620-55e8-438c-a1fe-ed82671a2450/allresources.access.asuser'];
  let APIURL = _constants2.serviceMethodConstants.getNavigations.replace('<ApplicationObjectId>', applicationID);
  const iamsToken = await msalInstance.getApiToken(scopes, window.localStorage.getItem('UserName'));
  iamsToken && _axios.default.get("".concat(_constants2.serviceMethodConstants.baseURL).concat(APIURL), {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  }).then(navItems => {
    if (navItems.data !== '' && navItems.data !== undefined && navItems.data.navigations.length > 0) {
      dispatch({
        type: _constants.CONSTANTS.GET_NAVIGATION_FULFILLED,
        payload: navItems.data.navigations
      });
    } else {
      _oneWeir.toastStatus.error(_languageMsg.languageMsg.NAVIGATION_EMPTY);
    }
  }).catch(err => {
    dispatch(_loader.loaderActions.hide());
    if (err.response !== undefined) {
      _oneWeir.toastStatus.error(err.response.statusText);
    }
  });
};
exports.getNavigation = getNavigation;
function onInAppSelectionChange(navItem, history) {
  const selectedNavLink = navItem.link;
  history.push(selectedNavLink);
  return {
    type: _constants.CONSTANTS.ON_INAPP_SELECT,
    payload: navItem
  };
}
const navigationActions = exports.navigationActions = {
  getNavigation,
  onInAppSelectionChange
};